import styled, { keyframes } from 'styled-components';

export const Wrap = styled.div`
  position: relative;
  height: 100%;
  min-height: 420px;
  margin-top: -10px;
  margin-right: -16px;
  background: #050b0c;
  overflow: hidden;
  user-select: none;

  @media only screen and (max-width: 767px) {
    margin-right: -12px;
  }
`;

export const CanvasLayer = styled.div`
  position: absolute;
  inset: 0;
`;

export const Overlay = styled.div`
  position: absolute;
  z-index: 3;
  pointer-events: none;
  > * {
    pointer-events: auto;
  }
`;

export const TopLeft = styled.div`
  position: absolute;
  top: 18px;
  left: 22px;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 22px;
  pointer-events: none;
  max-width: calc(100% - 330px);

  @media only screen and (max-width: 900px) {
    top: 14px;
    left: 14px;
    max-width: none;
  }
`;

export const Header = styled.div`
  position: static;
  pointer-events: none;
  min-width: 0;
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;

  h1 {
    margin: 0;
    font-size: 21px;
    font-weight: 600;
    letter-spacing: 0.2px;
    color: #eef4ff;
    line-height: 1.15;
  }

  p {
    margin: 0;
    font-size: 11px;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: #7c93b0;
    white-space: nowrap;
  }

  @media only screen and (max-width: 767px) {
    h1 { font-size: 17px; }
    p { font-size: 10px; }
  }
`;

export const TopRight = styled.div`
  position: absolute;
  top: 18px;
  right: ${(p) => (p.$panel ? 366 : 22)}px;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 14px;
  pointer-events: none;
  transition: right 0.25s ease;

  > * { pointer-events: auto; }

  @media only screen and (max-width: 900px) {
    right: 12px;
  }
`;

export const Stats = styled.div`
  display: flex;
  align-items: baseline;
  gap: 10px;
  color: #7f959b;
  font-size: 11px;
  letter-spacing: 0.2px;
  white-space: nowrap;

  span { white-space: nowrap; }

  b {
    color: #e6eef0;
    font-weight: 600;
    font-size: 12px;
  }

  span + span::before {
    content: '·';
    margin-right: 10px;
    color: #3f555b;
  }

  @media only screen and (max-width: 1100px) {
    display: none;
  }
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 12px;
  width: 220px;
  flex: 0 0 auto;
  border-radius: 10px;
  background: rgba(15, 23, 42, 0.55);
  border: 1px solid rgba(148, 163, 184, 0.16);
  backdrop-filter: blur(10px);
  transition: border-color 0.2s ease, background 0.2s ease;

  &:focus-within {
    border-color: rgba(56, 189, 248, 0.55);
    box-shadow: 0 0 0 3px rgba(56, 189, 248, 0.08);
  }

  svg { color: #7c93b0; flex-shrink: 0; }

  input {
    flex: 1;
    min-width: 0;
    background: transparent;
    border: 0;
    outline: none;
    color: #e6eefb;
    font-size: 12.5px;
  }

  input::placeholder { color: #6b7f99; }

  button {
    border: 0;
    background: transparent;
    color: #7c93b0;
    cursor: pointer;
    display: inline-flex;
    padding: 0;
  }

  @media only screen and (max-width: 900px) {
    top: 58px;
    right: 14px;
    width: 210px;
  }
`;

export const Legend = styled.div`
  position: absolute;
  left: 22px;
  bottom: 18px;
  z-index: 3;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.62);
  border: 1px solid rgba(148, 163, 184, 0.14);
  backdrop-filter: blur(10px);
  pointer-events: auto;

  > small {
    display: block;
    font-size: 9.5px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #6b7f99;
    margin-bottom: 7px;
  }

  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

export const LegendGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2px 14px;
`;

export const LegendItem = styled.button`
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 3px 4px;
  border: 0;
  background: transparent;
  border-radius: 6px;
  cursor: pointer;
  color: ${(p) => (p.$off ? '#4b5d75' : '#c3d1e2')};
  font-size: 11.5px;
  text-align: left;
  transition: background 0.15s ease, opacity 0.15s ease;

  &:hover { background: rgba(148, 163, 184, 0.08); }

  i {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background: ${(p) => p.$color};
    box-shadow: 0 0 9px ${(p) => p.$color};
    opacity: ${(p) => (p.$off ? 0.25 : 1)};
    flex-shrink: 0;
  }

  b {
    margin-left: auto;
    font-weight: 500;
    color: #6b7f99;
    font-size: 10.5px;
  }
`;

export const RightRail = styled.div`
  position: absolute;
  top: 72px;
  right: ${(p) => (p.$panel ? 366 : 22)}px;
  z-index: 3;
  width: 212px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  transition: right 0.25s ease;

  @media only screen and (max-width: 1100px) {
    display: none;
  }
`;

export const FilterPanel = styled.div`
  width: 100%;
  padding: 11px 12px 10px;
  border-radius: 12px;
  background: rgba(8, 14, 16, 0.66);
  border: 1px solid rgba(148, 163, 184, 0.14);
  backdrop-filter: blur(10px);
  pointer-events: auto;
`;

export const LevelBar = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 9px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);

  > span {
    font-size: 9.5px;
    letter-spacing: 1.2px;
    text-transform: uppercase;
    color: #6b7f99;
  }
`;

export const LevelButtons = styled.div`
  display: flex;
  gap: 4px;
  margin-left: auto;
`;

export const LevelButton = styled.button`
  width: 24px;
  height: ${(p) => (p.$level === 1 ? '24px' : '22px')};
  border-radius: ${(p) => (p.$level === 1 ? '50%' : '6px')};
  border: 1px solid
    ${(p) =>
      p.$level === 1 && p.$active
        ? p.$current
          ? 'rgba(224, 242, 254, 0.95)'
          : 'rgba(125, 211, 252, 0.75)'
        : p.$current
          ? 'rgba(248, 250, 252, 0.75)'
          : p.$active
            ? 'rgba(226, 232, 240, 0.38)'
            : 'rgba(148, 163, 184, 0.1)'};
  background: ${(p) =>
    p.$level === 1 && p.$active
      ? p.$current
        ? 'rgba(56, 189, 248, 0.42)'
        : 'rgba(56, 189, 248, 0.24)'
      : p.$current
        ? 'rgba(226, 232, 240, 0.24)'
        : p.$active
          ? 'rgba(226, 232, 240, 0.13)'
          : 'rgba(148, 163, 184, 0.04)'};
  color: ${(p) => (p.$level === 1 && p.$active ? '#f0f9ff' : p.$active ? '#f1f5f9' : '#5a6b72')};
  font-weight: ${(p) => (p.$current ? 700 : p.$level === 1 && p.$active ? 600 : 500)};
  box-shadow: ${(p) => (p.$level === 1 && p.$active ? '0 0 10px rgba(56, 189, 248, 0.45)' : 'none')};
  font-size: 11px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: rgba(56, 189, 248, 0.6);
    color: #e8f6ff;
  }
`;

export const FilterTitle = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  margin-bottom: 7px;

  strong {
    font-size: 10px;
    letter-spacing: 1.4px;
    text-transform: uppercase;
    color: #8ba1a8;
    font-weight: 600;
  }

  small {
    font-size: 9.5px;
    color: #4f6266;
  }
`;

export const FilterList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`;

export const FilterSection = styled.div`
  margin-top: 8px;
  padding-top: 7px;
  border-top: 1px solid rgba(148, 163, 184, 0.1);

  > small {
    display: block;
    font-size: 9px;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: #4f6266;
    margin: 0 0 4px 4px;
  }
`;

export const FilterFooter = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  margin-top: 9px;
  padding-top: 8px;
  border-top: 1px solid rgba(148, 163, 184, 0.1);
  color: #5f7377;
  font-size: 9.5px;
  line-height: 1.35;

  i {
    width: 16px;
    height: 0;
    border-top: 1px dotted #f2c14e;
    flex-shrink: 0;
  }
`;

export const FilterActions = styled.div`
  display: flex;
  gap: 6px;
  margin-top: 8px;

  button {
    flex: 1;
    padding: 5px 6px;
    border-radius: 7px;
    border: 1px solid rgba(148, 163, 184, 0.16);
    background: rgba(148, 163, 184, 0.06);
    color: #b9c8da;
    font-size: 10px;
    cursor: pointer;
    transition: background 0.15s ease, border-color 0.15s ease;
  }

  button:hover {
    background: rgba(56, 189, 248, 0.14);
    border-color: rgba(56, 189, 248, 0.38);
  }
`;

export const LegendNote = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  padding-top: 7px;
  border-top: 1px solid rgba(148, 163, 184, 0.1);
  color: #6b7f99;
  font-size: 10px;
  letter-spacing: 0.2px;

  i {
    width: 20px;
    height: 0;
    border-top: 1px dotted #f2c14e;
    flex-shrink: 0;
  }
`;

export const Controls = styled.div`
  position: absolute;
  right: ${(p) => (p.$panel ? 366 : 22)}px;
  bottom: 18px;
  z-index: 3;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 6px;
  pointer-events: auto;
  transition: right 0.25s ease;

  @media only screen and (max-width: 900px) {
    right: 12px;
    bottom: 14px;
  }
`;

export const ControlButton = styled.button`
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  border: 1px solid rgba(148, 163, 184, 0.16);
  background: rgba(15, 23, 42, 0.72);
  color: #c3d1e2;
  cursor: pointer;
  backdrop-filter: blur(8px);
  transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
  font-size: 14px;

  &:hover {
    background: rgba(56, 189, 248, 0.14);
    border-color: rgba(56, 189, 248, 0.4);
    color: #e8f6ff;
  }

  &:disabled { opacity: 0.4; cursor: default; }
`;

export const Panel = styled.aside`
  display: ${(p) => (p.$open ? 'flex' : 'none')};
  flex-direction: column;
  width: 100%;
  max-height: 48vh;
  overflow-y: auto;
  border-radius: 12px;
  background: rgba(8, 14, 16, 0.66);
  border: 1px solid rgba(148, 163, 184, 0.14);
  backdrop-filter: blur(10px);
  pointer-events: auto;

  &::-webkit-scrollbar { width: 6px; }
  &::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.25);
    border-radius: 3px;
  }
`;

export const PanelHead = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px 8px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.1);

  i {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${(p) => p.$color || '#38bdf8'};
    box-shadow: 0 0 12px ${(p) => p.$color || '#38bdf8'};
    flex-shrink: 0;
  }

  div { min-width: 0; }

  small {
    display: block;
    font-size: 9.5px;
    letter-spacing: 1.1px;
    text-transform: uppercase;
    color: #6b7f99;
  }

  strong {
    display: block;
    font-size: 14px;
    color: #eef4ff;
    font-weight: 600;
    line-height: 1.25;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  button {
    margin-left: auto;
    border: 0;
    background: transparent;
    color: #7c93b0;
    cursor: pointer;
    font-size: 16px;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    flex-shrink: 0;

    &:hover { background: rgba(148, 163, 184, 0.1); color: #e8f0fb; }
  }
`;

export const PanelBody = styled.div`
  padding: 10px 12px 12px;
  overflow-y: auto;
  flex: 1;
  color: #b9c8da;
  font-size: 12px;

  &::-webkit-scrollbar { width: 8px; }
  &::-webkit-scrollbar-thumb {
    background: rgba(148, 163, 184, 0.25);
    border-radius: 8px;
  }
`;

export const PanelMeta = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 6px 10px;
  margin-bottom: 10px;

  span {
    color: #6b7f99;
    font-size: 11px;
    white-space: nowrap;
  }

  b {
    color: #d6e2f1;
    font-weight: 500;
    font-size: 12px;
    text-align: right;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const Tag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 10.5px;
  letter-spacing: 0.3px;
  color: #cbd8e8;
  background: rgba(148, 163, 184, 0.1);
  border: 1px solid rgba(148, 163, 184, 0.16);
  margin: 0 5px 5px 0;
`;

export const ActionRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 4px;
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 6px 10px;
  border-radius: 8px;
  border: 1px solid rgba(56, 189, 248, 0.32);
  background: rgba(56, 189, 248, 0.13);
  color: #d9f2ff;
  font-size: 12px;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: rgba(56, 189, 248, 0.22);
    border-color: rgba(56, 189, 248, 0.55);
  }

  &.ghost {
    border-color: rgba(148, 163, 184, 0.2);
    background: rgba(148, 163, 184, 0.06);
    color: #b9c8da;

    &:hover { background: rgba(148, 163, 184, 0.14); }
  }

  &:disabled { opacity: 0.5; cursor: default; }
`;

export const Hint = styled.div`
  margin-top: 14px;
  padding-top: 12px;
  border-top: 1px solid rgba(148, 163, 184, 0.1);
  color: #62768f;
  font-size: 11px;
  line-height: 1.55;
`;

export const CenterOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgba(6, 10, 19, 0.55);
  color: #b9c8da;
  font-size: 12.5px;
  backdrop-filter: blur(2px);
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const Spinner = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid rgba(148, 163, 184, 0.2);
  border-top-color: #38bdf8;
  animation: ${spin} 0.9s linear infinite;
`;

export const Empty = styled.div`
  position: absolute;
  inset: 0;
  z-index: 4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #93a7c1;
  text-align: center;
  padding: 24px;

  strong { color: #e6eefb; font-size: 15px; font-weight: 600; }
  span { font-size: 12.5px; max-width: 380px; line-height: 1.55; }
`;
